<mat-table [dataSource]="dataSource" class="mat-elevation-z8">
    <ng-container matColumnDef="username">
        <mat-header-cell *matHeaderCellDef> Nom </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.username}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef> Email </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.email}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="Gsm">
        <mat-header-cell *matHeaderCellDef> Gsm </mat-header-cell>
        <mat-cell *matCellDef="let element"> {{element.gsm}} </mat-cell>
    </ng-container>
    <ng-container matColumnDef="application">
        <mat-header-cell *matHeaderCellDef> Application </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <ul>
                <li *ngFor="let a of element?.applications"> {{a?.application.ApplicationName}} - {{a?.role.name}}</li>
            </ul>

        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="isActive">
        <mat-header-cell *matHeaderCellDef> Actif </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <!-- <mat-slide-toggle class="example-margin" (click)="openDialogIsActive(element.isActive, element.id)" -->
            <mat-slide-toggle class="example-margin" (click)="activeDesactive(element.isActive, element.id)"
                [(ngModel)]="element.isActive" color="primary"> </mat-slide-toggle>
        </mat-cell>
    </ng-container>
    <ng-container matColumnDef="password">
        <mat-header-cell *matHeaderCellDef> Mot de passe </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <fa-icon [icon]="faEnvelop" (click)="openDialogSendMailPassword(element.username)"></fa-icon>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="EmailNotificationEnabled">
        <mat-header-cell *matHeaderCellDef> Notification via mail </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <mat-checkbox color="primary" [(ngModel)]="element.emailNotificationsEnabled"></mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="SmsNotificationEnabled">
        <mat-header-cell *matHeaderCellDef> Notification via sms </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <mat-checkbox color="primary" [(ngModel)]="element.smsNotificationsEnabled"></mat-checkbox>
        </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Edit">
        <mat-header-cell *matHeaderCellDef> Modifier </mat-header-cell>
        <mat-cell *matCellDef="let element">
            <fa-icon [icon]="faPen" (click)="openDialogEditUsers(c); $event.stopPropagation()"></fa-icon>
        </mat-cell>
    </ng-container>


    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
</mat-table>